import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';

@Component({
  selector: 'landing-flow-section',
  templateUrl: './flow.component.html',
  styleUrls: ['./flow.component.scss'],
})
export class LandingFlowSectionComponent implements OnInit {
  @ViewChild('video', { static: false }) private videoRef: ElementRef;

  isMobile;
  videoPoster;
  videoWebm;
  videoMp4;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    // TODO: need refactoring (use store.screenSize instead of store.isMobile)
    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;

      this.videoPoster = `/assets/video/MagicBook_baby_45sec_${
        this.isMobile ? '1x1' : '16x9'
      }_poster.jpg`;
      this.videoWebm = `/assets/video/MagicBook_baby_45sec_${
        this.isMobile ? '1x1' : '16x9'
      }.webm`;
      this.videoMp4 = `/assets/video/MagicBook_baby_45sec_${
        this.isMobile ? '1x1' : '16x9'
      }.mp4`;

      if (
        !('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window)
      ) {
        this.onVideoIntersected();
      }
    });
  }

  onVideoIntersected() {
    this.videoRef.nativeElement.muted = 'muted';
    this.videoRef.nativeElement.play();
  }

  isVideoReady() {
    return this.videoPoster && this.videoWebm && this.videoMp4;
  }
}
